import {
    Avatar,
    Button,
    Container,
    Heading,
    Input,
    Text,
    VStack,
  } from '@chakra-ui/react';
  import React from 'react';
  import { Link } from 'react-router-dom';


const Signup = () => {
  return (
    <Container h={"100vh"} maxWw={"xl"} p={"8"} >
    <VStack h={"full"} justifyContent={"center"} spacing={"8"} alignItems={"stretch"} >
        <Heading>VIDEO HUB</Heading>
        <Avatar alignSelf={'center'} boxSize={'32'} />
        <Input placeholder='Name' focusBorderColor='purple.500' required/>
        <Input type='email' placeholder='Email' focusBorderColor='purple.500' required/>
        <Input type='password' placeholder='Password' focusBorderColor='purple.500' required/>
        <Button variant={"solid"} colorScheme='purple'>Sign Up</Button>
        <Text alignSelf={"flex-end"}>Already Registered ? {"  "}
            <Button colorScheme='purple' variant={"link"}>
                <Link to={"/login"}>Log In</Link>
            </Button>
        </Text>
    </VStack>

</Container>
  )
}

export default Signup